import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

import { AngleComponent } from './components/angle/angle.component';
import { CheckboxMultiselectComponent } from './components/checkbox-multiselect/checkbox-multiselect.component';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import { RegionSubregionSelectorComponent } from './components/region-subregion-selector/region-subregion-selector.component';
import { SliderComponent } from './components/slider/slider.component';
import { UploadImageComponent } from './components/upload-image/upload-image.component';

@NgModule({
  imports: [
    AngleComponent,
    CheckboxMultiselectComponent,
    ColorPickerComponent,
    RegionSubregionSelectorComponent,
    SliderComponent,
    UploadImageComponent,
  ],

  exports: [
    ReactiveFormsModule,

    AngleComponent,
    CheckboxMultiselectComponent,
    ColorPickerComponent,
    RegionSubregionSelectorComponent,
    SliderComponent,
    UploadImageComponent,

    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
  ],
})
export class SharedFormsModule {}
